<template>
<div>
  <!-- <span v-if="testObject" v-text="testObject" ></span> -->

<!-- https://serversideup.net/uploading-files-vuejs-axios/ -->

<!-- <template v-for="tour in toursList">
  <ul>
      <li><router-link tag="a" :to="'/reservar/'+tour.id"> <font-awesome-icon icon="users" /> {{tour.nombre}}</router-link></li>
  </ul>
</template> -->
<div class="section">
  <div class="field">

    <label>Title</label><br>
    <input class="input" v-model="title" placeholder="Title">

    <label>Description</label><br>
    <textarea class="textarea" v-model="description" placeholder="Description"></textarea>

    <label>Troubleshoot</label><br>
    <textarea class="textarea" v-model="troubleshoot" placeholder="Troubleshoot"></textarea>

    <div class="field">
      <label>Support type</label><br>
      <div class="select is-fullwidth">
        <!-- <select v-model="supportType" @change="getSupportType"> -->
          <select v-model="supportType">
          <option class="is-size-7" v-for="type in supportTypesList" :key="type.id" :value="type.id">{{type.name}}</option>
        </select>
      </div>
    </div>

    <div class="field">
      File<br>
      <input class="input" v-model="file" placeholder="File">
    </div>

    <div class="field">
      <label>Classification</label><br>
      <input class="input" v-model="classification" placeholder="Classification">
      <!-- <div class="select is-fullwidth">
        <select v-model="classification" @change="getTipos">
          <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option>
        </select>
      </div> -->
    </div>

    <label>Handled by</label><br>
    <input class="input" v-model="handledBy" placeholder="Handled by">

    <label>url</label><br>
    <input class="input" v-model="url" placeholder="url">

    <label>Phone</label><br>
    <input class="input" v-model="phone" placeholder="Phone">

    <a @click="createSupport" class="button is-info">Create</a>



  </div>
  
</div>
  
  

</div>
</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'

export default {
  components:{
    DatePick,
    VueClockPicker
  },
  data () {
    return {
      subSelect:'',
      toursList:[],
      tiposList:[],
      tiposGeneralesList:[],
      idiomasList:[],
      nacionalidadesList:[],
      salidasList:[],
      tour:'',
      tour2:'',
      tour3:'',
      tour4:'',
      tipo:'',
      nacionalidad:'',
      idioma:'',
      salida:'',
      fecha:moment().add(1, 'day').format('YYYY-MM-DD'),
      fecha2:'',
      fecha3:'',
      fecha4:'',
      hora:'',
      searchText:'',
      searchText2:'',
      items:[],
      items2:[],
      hotel:'',
      hotelId:'',
      hotelPickup:'',
      vendedor:'',
      vendedorId:null,
      adultos:2,
      ninos:0,
      infantes:0,
      cliente:'',
      habitacion:'',
      cupon:'',
      balance:0,
      moneda:null,
      monedasList:[],
      observaciones:'',
      confirma:'',
      servicio:1,
      horario:1,
      cortesia:2,
      testObject:[],
      files: '',
      imagen: null,

      title: '',
      description: '',
      troubleshoot: '',
      supportType: '',
      classification: '',
      handledBy: '',
      url: '',
      phone: '',
      file: '',
      supportTypesList :[],
      host: 'support.sistemy.mx'
      // host: 'localhost'

    }
  },
  created(){
    this.getTiposGenerales();
    this.getHoteles();
    this.getVendedores();
    this.getMonedas();
    this.getTours();
    this.getIdiomas();
    this.getNacionalidades();
    this.getSalidas();
    this.getSupportType();
    // this.test();
  },
  computed:{
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.items;
      }
      return self.items.filter(function(item){

        var str = self.searchText;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    },
    itemsSearched2 : function(){
      var self = this;
      if( self.searchText2 == ''){
        return self.items2;
      }
      return self.items2.filter(function(item){

        var str = self.searchText2;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    }
  },
  methods:{
    clear () {
      console.log("limpiando form");
      this.subSelect=1;
      this.tour='';
      this.tour2='';
      this.tour3='';
      this.tour4='';
      this.tipo='';
      this.nacionalidad='';
      this.idioma='';
      this.salida='';
      this.fecha=moment().add(1, 'day').format('YYYY-MM-DD');
      this.fecha2='';
      this.fecha3='';
      this.fecha4='';
      this.hora='';
      this.searchText='';
      this.searchText2='';
      this.hotel='';
      this.hotelId='';
      this.hotelPickup='';
      this.vendedor='';
      this.vendedorId=null;
      this.adultos=2;
      this.ninos=0;
      this.infantes=0;
      this.cliente='';
      this.habitacion='';
      this.cupon='';
      this.balance=0;
      this.moneda=null;
      this.observaciones='';
      this.confirma='';
      this.servicio=1;
      this.horario=1;
      this.cortesia=2;
      
      this.title='',
      this.description='',
      this.troubleshoot='',
      this.supportType=2,
      this.classification='',
      this.handledBy='',
      this.url='',
      this.phone='',
      this.file=''
    },
    test(){
      console.log("En test");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'reservaciones',
          where: ''
      }
          axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ console.log(response,'<-- response de test')
         if (response.status == 200 ) { console.log("bien test");
         this.testObject=response
           this.$snotify.success('test', 'Correcto', {
               timeout: 4000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

    },
    fechas (r) {
      if(r==2){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      }else if (r==3){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
        this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      }else if(r==4){
        this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
        this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
        this.fecha4=moment().add(4, 'days').format('YYYY-MM-DD');
      }
    },
    createSupport () {
      var instancia=this;
      var params = {
        action : 'insertPost',
        table : 'support',
        columns : 'title,description,supportType,file,classification,handledBy,url,troubleshoot,phone,status',
        values : ` '${instancia.title}','${instancia.description}','${instancia.supportType}','${instancia.file}','${instancia.classification}','${instancia.handledBy}','${instancia.url}','${instancia.troubleshoot}','${instancia.phone}',1 `
      }
      console.log(params,'<--params in createSupport')
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
       .then((response)=>{
         if (response.status == 200 ) {
           this.$snotify.success('Insterted', 'Correct', {
             
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No creado');
         }
         this.clear();
       });
    },
    reservar () {
      console.log("reservar 1");
      var estancia=this;
      var posicion=1;
      if(this.ninos==null){
        var confirmacion = this.vendedor.substr(0,2)+this.tour.nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+this.adultos+'-'+$cookies.get('RhSession').name.substr(0,1).toUpperCase();
      }else{
        var confirmacion = this.vendedor.substr(0,2)+this.tour.nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+this.adultos+'-'+this.ninos+$cookies.get('RhSession').name.substr(0,1).toUpperCase();
      }
      this.confirma=confirmacion;
      $("#modalConfirmacion").addClass("is-active");
      console.log(confirmacion);
      var params = {
        action : 'insertPost',
        table : 'reservaciones',
        columns : 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion, servicio, cortesia, horario',
        values : ` ${$cookies.get('RhSession').id}, '${estancia.fecha}',${estancia.tour.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}',${estancia.servicio},${estancia.cortesia},${estancia.horario} `
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

       if(this.subSelect==2 || this.subSelect==3 || this.subSelect==4){
         var posicion=2;
         console.log("Insertando el día 2 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha2}',${estancia.tour2.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha2}',${estancia.tour2.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }

       if(this.subSelect==3 || this.subSelect==4){
         var posicion=3;
         console.log("Insertando el día 3 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha3}',${estancia.tour3.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha3}',${estancia.tour3.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }

       if(this.subSelect==4){
         var posicion=4;
         console.log("Insertando el día 4 de la reservación");
      //    axios.post('http://localhost:3000/justInsert',{
      //    table: 'reservaciones',
      //    columns: 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion',
      //    values:` ${$cookies.get('RhSession').id}, '${estancia.fecha4}',${estancia.tour4.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `
      //  })
      var columns = 'usuarioIdCreado, fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, hotelId, habitacion, cupon, pickup, vendedorId, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion';
      var values=` ${$cookies.get('RhSession').id}, '${estancia.fecha4}',${estancia.tour4.id},${estancia.tipo},${estancia.salida},${estancia.nacionalidad},${estancia.idioma},${estancia.adultos},${estancia.ninos},${estancia.infantes},'${estancia.cliente}',${estancia.hotelId},'${estancia.habitacion}','${estancia.cupon}','${estancia.hora}',${estancia.vendedorId},${estancia.balance},${estancia.moneda},'${estancia.observaciones}',${estancia.subSelect},${posicion},'${estancia.salida+estancia.adultos+estancia.cliente+estancia.hotelId+estancia.vendedor+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${confirmacion}' `;
      axios.get(`http://${this.host}/assignFunction.php?action=justInsert&tabla=reservaciones&columns=${columns}&values=${values}`)
       .then(function(response){
         if (response.status == 200 ) {
           estancia.$snotify.success('Reservado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
       }
    },
    elegido:function(item){
      this.searchText='';
      this.hotel = item.nombre;
      this.hotelId = item.id;
      this.hotelPickup = item.pickup;
      console.log(this.tour.pickup,'tour.pickup');
      console.log(item,'item');
      if(this.tour.pickup=='' || this.tour.pickup==null ){
        this.hora=item.pickup;
      }
    },
    elegido2:function(item){
      this.searchText2='';
      this.vendedor = item.nombre;
      this.vendedorId = item.id;
    },
    getHoteles(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre, pickup',
        //   table: 'hoteles',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre, pickup`;
        var tabla = "hoteles";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            // estancia.hotelesList  = response.data;
            estancia.items = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getMonedas(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
            estancia.moneda=response.data[0].id;
          }else{
            console.log('error');
          }
        });
    },
    getVendedores(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'vendedores',
        //   where: 'activo=1',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "vendedores";
        var where = "activo=1";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.items2 = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getTours(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"tour",
      //     where:``,
      //     condition:" order by nombre "
      //   })
      var select = `*`;
      var tabla = "tour";
      var where = "";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.toursList=response.data;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getTipos(){
      console.log(this.tour,'tour');
      this.hora=this.tour.pickup;
      console.log(this.hora,'hora');
      if(this.tour!=''){
        var estancia=this;
        // axios.post('http://localhost:3000/justRead',{
        //     select:` * `,
        //     table:"tipo",
        //     where:` tourId like '%,${estancia.tour.id},%' `,
        //     condition:""
        //   })
        var select = `*`;
        var tabla = "tipo";
        var where = ` tourId like '%25%2C${estancia.tour.id}%2C%25' `;
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposList=response.data;
                if(estancia.tour.id!=6){
                  console.log(response,'response getTipos')
                  estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
      }
    },
    getSupportType(){
        var estancia=this;
        var select = `*`;
        var tabla = "supportType";
        var where = ` `;
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
              console.log(response.data,'<--support type list')
                estancia.supportTypesList=response.data;
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    getTiposGenerales(){
      console.log("en reservar")
        var estancia=this;
        // axios.post('http://localhost:3000/justRead',{
        //     select:` * `,
        //     table:"tipo",
        //     where:` tourId = "0" `,
        //     condition:""
        //   })
        var select = `*`;
        var tabla = "tipo";
        var where = "tourId = '0'";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposGeneralesList=response.data;
                if(estancia.tipo==''){
                // if(estancia.tipo=='' || (estancia.tiposList.length<1 && tour.id==6) ){
                 estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    getIdiomas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"idioma",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "idioma";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.idiomasList=response.data;
              estancia.idioma=response.data[4].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getSalidas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"lugar_salida",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "lugar_salida";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.salidasList=response.data;
              estancia.salida=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getNacionalidades(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"nacionalidad",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "nacionalidad";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.nacionalidadesList=response.data;
              estancia.nacionalidad=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    tipoCuponF(n){
      if(this.tipoCupon==1){
        $("#1").addClass("is-active");
      }
      if(n==2){
        $("#2").addClass("is-active");
      }
      if(n==3){
        $("#3").addClass("is-active");
      }
      if(n==4){
        $("#4").addClass("is-active");
      }
      this.tipoCupon=n;
    },
    cerrarModalConfirmacion:function(){
      this.clear();
      $("#modalConfirmacion").removeClass("is-active");
    },
  },
  mixins: [searchMix]
}
</script>
